module.exports = "query GetFlags {\n  flags {\n    ...FlagFragment\n  }\n}\n"